import React from "react"
import { SectionLayouts } from "../../../interfaces/Page"
import { ALayout, BLayout, CLayout } from "./styles"

type Props = {
  layout: SectionLayouts
  children: React.ReactNode
}

const SectionGrid: React.FC<Props> = ({ layout, children }): JSX.Element => {
  if (layout === SectionLayouts.A) {
    return <ALayout>{children}</ALayout>
  }

  if (layout === SectionLayouts.B) {
    return <BLayout>{children}</BLayout>
  }

  return <CLayout>{children}</CLayout>
}

export default SectionGrid
